import styled from '@emotion/styled'
import { NoData } from '@components/noData'
import { useDatasetQueryContext } from '@datasets/dataset-query-context/hooks'
import { COL_WIDTHS } from './context/column-width-context'

const Container = styled.div`
  position: absolute;
  top: 50px;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
  pointer-events: none;
`

interface Props {
  fixedColumnCount: 1 | 2
  width: number
}

export const NoRows = ({ fixedColumnCount, width }: Props) => {
  const { updateQueryOptionsByFieldId, updateUrlParams } = useDatasetQueryContext()

  return (
    <Container style={{ width: width - fixedColumnCount * COL_WIDTHS.fixed }}>
      <NoData
        callToActionBtns={[
          {
            btnText: 'reset filters',
            onClick: handleClick,
          },
        ]}
        imageFileName="undraw_add_notes.svg"
        text={{
          title: 'No data to display',
          body: {
            mainText: 'There is no data matching the filters you applied.',
            helperText: {
              text: 'Try adjusting your filters or resetting them.',
            },
          },
        }}
      />
    </Container>
  )

  function handleClick() {
    const nextQueryOptions = updateQueryOptionsByFieldId(null, {})
    updateUrlParams(nextQueryOptions)
  }
}
